/* tslint:disable */
/* eslint-disable */
/**
 * Pitango Market API
 * Canonical public and administrative HTTP API contract.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    ApiErrorEnvelope,
    CartPayloadAddCartItemRequest,
    CartPayloadRemoveCartItemRequest,
    CartResponseAddCartItemResponse,
    CartResponseGetCartItemsResponse,
    CartResponseRemoveCartItemResponse,
    LanguageCode,
} from '../models/index';

export interface CartAddCartItemRequest {
    cartPayloadAddCartItemRequest: CartPayloadAddCartItemRequest;
}

export interface CartGetCartItemsRequest {
    languageCode: LanguageCode;
}

export interface CartRemoveCartItemRequest {
    cartPayloadRemoveCartItemRequest: CartPayloadRemoveCartItemRequest;
}

/**
 *
 */
export class CartApi extends runtime.BaseAPI {

    /**
     * Creates request options for cartAddCartItem without sending the request
     */
    async cartAddCartItemRequestOpts(requestParameters: CartAddCartItemRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cartPayloadAddCartItemRequest'] == null) {
            throw new runtime.RequiredError(
                'cartPayloadAddCartItemRequest',
                'Required parameter "cartPayloadAddCartItemRequest" was null or undefined when calling cartAddCartItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/cart`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['cartPayloadAddCartItemRequest'],
        };
    }

    /**
     * Add Cart Item
     */
    async cartAddCartItemRaw(requestParameters: CartAddCartItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartResponseAddCartItemResponse>> {
        const requestOptions = await this.cartAddCartItemRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Add Cart Item
     */
    async cartAddCartItem(requestParameters: CartAddCartItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartResponseAddCartItemResponse> {
        const response = await this.cartAddCartItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for cartGetCartItems without sending the request
     */
    async cartGetCartItemsRequestOpts(requestParameters: CartGetCartItemsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling cartGetCartItems().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/cart/{languageCode}`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Cart Items
     */
    async cartGetCartItemsRaw(requestParameters: CartGetCartItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartResponseGetCartItemsResponse>> {
        const requestOptions = await this.cartGetCartItemsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Cart Items
     */
    async cartGetCartItems(requestParameters: CartGetCartItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartResponseGetCartItemsResponse> {
        const response = await this.cartGetCartItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for cartRemoveCartItem without sending the request
     */
    async cartRemoveCartItemRequestOpts(requestParameters: CartRemoveCartItemRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['cartPayloadRemoveCartItemRequest'] == null) {
            throw new runtime.RequiredError(
                'cartPayloadRemoveCartItemRequest',
                'Required parameter "cartPayloadRemoveCartItemRequest" was null or undefined when calling cartRemoveCartItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/cart`;

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['cartPayloadRemoveCartItemRequest'],
        };
    }

    /**
     * Remove Cart Item
     */
    async cartRemoveCartItemRaw(requestParameters: CartRemoveCartItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CartResponseRemoveCartItemResponse>> {
        const requestOptions = await this.cartRemoveCartItemRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Remove Cart Item
     */
    async cartRemoveCartItem(requestParameters: CartRemoveCartItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CartResponseRemoveCartItemResponse> {
        const response = await this.cartRemoveCartItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
